import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEllipseCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={115} height={141} fill='none' {...props}>
    <circle cx={36.5} cy={69.5} r={78.5} fill='currentColor' />
  </svg>
);
export default SvgEllipseCircle;
